import React, { useEffect, useState, useRef } from "react";

// Components
import ScrollTop from "components/layout/ScrollTop";

// Assets
import otcImg from "assets/images/otc_1.jpg";
import otcImg2 from "assets/images/otc_2.jpg";
import otcImg3 from "assets/images/otc_3.jpg";
import otcImg4 from "assets/images/otc_4.jpg";

const Otc = (props) => {
  const work = {
    images: {
      one: otcImg,
      two: otcImg2,
      three: otcImg3,
      four: otcImg4
    },
    title: "OTC",
    link: null,
    sin_link: process.env.REACT_APP_SINEGY_URL,
    sc_link: process.env.REACT_APP_SC_URL
  };

  const isMounted = useRef(false);
  const [scrollTopState, setScrollTopState] = useState(false);

  const checkScrollPos = async () => {
    const state = (props.scrollTop >= 1000 ? true : false);
    await setScrollTopState(state);
  }

  useEffect(() => {
    isMounted.current = true;
  }, []);

  useEffect(() => {
    if (isMounted.current) { checkScrollPos(); }
  }, [isMounted, props.scrollTop]);

  return (
    <div id="works" className="root-con">
      {scrollTopState && (
        <ScrollTop backToTop={props.scrollToTop} />
      )}

      <div className="full-page">
        <div className="full-page-con container">
          <div className="jumbotron my-auto">
            <div className="row">
              <div className="work-view-col col-lg-10 col-12">

                <div className="work-view-box">
                  <p className="work-title">{ work.title }</p>
                  <img className="work-img" src={work.images.one} alt=""/>

                  <div className="work-section">
                    <p className="work-box-title">What is { work.title }?</p>

                    <div className="work-box">
                      <p className="work-text">
                        { work.title } was a platform built for over-the-counter ({ work.title }) style Digital Assets trading, whereby <a 
                          className="work-text-link"
                          href={work.sin_link}
                          rel="noreferrer"
                          target="_blank">SINEGY</a> acted as the broker-dealer of the platform, receiving users' orders & executing them accordingly.
                      </p>
                    </div>
                  </div>

                  <div className="work-section">
                    <p className="work-box-title">
                      Who Was It Built For?
                    </p>

                    <div className="work-box">
                      <p className="work-text">
                        { work.title } was a project built for <a 
                        className="work-text-link"
                        href={work.sin_link}
                        rel="noreferrer"
                        target="_blank">SINEGY</a> while I was under the employment of the company. <a 
                        className="work-text-link"
                        href={work.sin_link}
                        rel="noreferrer"
                        target="_blank">SINEGY</a> is one of Malaysia's own Fintech startup companies from Penang that is fully regulated by <a 
                          className="work-text-link"
                          href={work.sc_link}
                          rel="noreferrer"
                          target="_blank">Securities Commission Malaysia</a> (SC).
                      </p>
                    </div>
                  </div>

                  <div className="work-section">
                    <p className="work-box-title">
                      How { work.title } works?
                    </p>

                    <div className="work-box">
                      <p className="work-text">
                        People who are interested to trade with OTC would have to register as a user on { work.title }. Once successfully registered, user would then have to register their crypto wallets or banking information to start trading.
                      </p>
                    </div>

                    <img className="work-img" src={work.images.two} alt="" width="600px" height="auto"/>

                    <div className="work-box">
                      <p className="work-text">
                        Once an order has been placed & transaction has been made, user would then have to wait for <a 
                        className="work-text-link"
                        href={work.sin_link}
                        rel="noreferrer"
                        target="_blank">SINEGY</a>'s confirmation of the transaction. The trade would be concluded once transaction has been confirmed.
                      </p>
                    </div>

                    <img className="work-img" src={work.images.three} alt="" width="600px" height="auto"/>

                    <div className="work-box">
                      <p className="work-text">
                        For every trade that was executed, users can refer to their trades data through Trade History.
                      </p>
                    </div>

                    <img className="work-img" src={work.images.four} alt="" width="600px" height="auto"/>
                  </div>

                  <div className="work-section">
                    <p className="work-box-title">
                      What Did I Work On?
                    </p>

                    <div className="work-box">
                      <p className="work-text">
                        I was tasked to work on both Front & Back End.
                      </p>
                    </div>
                  </div>

                  <div className="work-section">
                    <p className="work-box-title">
                      Where Can I See This Project?
                    </p>

                    <div className="work-box">
                      <p className="work-text">
                        Due to the launch of a new & more advanced Digital Assets Exchange (DAX) platform by <a 
                          className="work-text-link"
                          href={work.sin_link}
                          rel="noreferrer"
                          target="_blank">SINEGY</a>, { work.title } is no longer operational or available for viewing.
                      </p>
                    </div>
                  </div>

                  <div className="tech-stack work-section">
                    <p className="work-box-title">
                      Tech Stack
                    </p>

                    <div className="work-box">
                      <p className="work-text">
                        MySQL, Laravel, Bootstrap 4.
                      </p>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Otc;